import { getImageMetadataFromBlob } from './get-image-metadata.ts';
import { getGifMetadataFromBlob, isGifMimeType } from './gif-metadata.ts';
import type { MediaMetadata } from './media-metadata-types.ts';

export type { MediaMetadata, MediaNativeSize } from './media-metadata-types.ts';

export function getMediaMetadataFromBlob(input: {
  blob: Blob;
  mimeType?: string | null;
}): Promise<MediaMetadata | null> {
  const mimeType = input.mimeType ?? input.blob.type;

  if (isGifMimeType(mimeType)) {
    return getGifMetadataFromBlob({ blob: input.blob, mimeType });
  }

  return getImageMetadataFromBlob({ blob: input.blob, mimeType });
}
